import * as React from 'react'
import { Button } from 'primereact/button'
import InputField from 'app/shared/components/InputField'
import { InputProps } from './InputTypes'

interface Props extends InputProps {
    items: Array<{ label: string; onClick?: () => void }>
}

const InputAmount = React.forwardRef<HTMLInputElement, Props>(
    (
        {
            items,
            value,
            onChange,
            onClear,
            id,
            label,
            placeholder,
            helpId,
            helpMsg,
            onBlur,
            ...rest
        },
        ref
    ) => {
        const inputAmountRef = React.useRef<HTMLInputElement>(null)
        React.useImperativeHandle(ref, () => inputAmountRef.current, [
            inputAmountRef.current,
        ])

        return (
            <>
                <InputField
                    ref={inputAmountRef}
                    inputMode="numeric"
                    className="-number"
                    id={id}
                    label={label}
                    placeholder={placeholder}
                    helpId={helpId}
                    helpMsg={helpMsg}
                    value={value}
                    onChange={onChange}
                    onClear={onClear}
                    onBlur={onBlur}
                    optionRightElement={<span className="unit-txt">원</span>}
                    {...rest}
                />
                <div className="tabs-wrap mt-12">
                    <div className="tabs-tags -sub -reel">
                        <div className="p-tabmenu-nav">
                            {items.map((item, index) => (
                                <Button
                                    key={index}
                                    label={item.label}
                                    className="p-menuitem-link"
                                    onMouseDown={item.onClick}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            </>
        )
    }
)

export default InputAmount
